<template>
  <div id="rootDiv">
    <!-- <nav-head></nav-head> -->
    <div class="instanceCellFather">
      <div
        v-for="(i, index) in instances"
        v-bind:key="index"
        class="instanceCell"
      >
        <!-- instance的基本信息 -->
        <div>
          <p>
            <span class="instanceName">{{ i.name }}</span>
            <span class="noNameInstance">(iid:{{ i.id }})</span>
            <a-tag
              color="blue"
              class="instanceTag"
              v-if="i.algorithm.trainable"
            >
              算法实例</a-tag
            >
            <a-tag
              color="green"
              v-for="r in i.tags"
              v-bind:key="r"
              class="instanceTag"
            >
              {{ r }}</a-tag
            >
          </p>
          <a-row
            class="belowHead"
            type="flex"
            justify="space-between"
            align="bottom"
          >
            <a-col>
              <a-icon type="clock-circle" style="margin-right: 0.2rem" />
              {{ i.add_time.slice(0, 10) }}
              <a-icon
                type="user"
                style="margin-left:1rem margin-right:0.2rem"
              />{{ i.user.name }}
              <span style="padding-left: 2rem">
                <alg-button
                  v-if="i.algorithm.trainable"
                  :aId="i.algorithm.id"
                  :aName="i.algorithm.name"
                ></alg-button
              ></span>
            </a-col>
            <!-- 操作按钮 -->
            <a-col>
              <a-button
                shape="round"
                class="marginRightSmall"
                @click="changeShow(index)"
              >
                {{ i.show ? "折叠" : "详情" }}
              </a-button>
              <a-button
                shape="round"
                class="marginRightSmall"
                @click="toHelpPage(i.algorithm.id)"
                v-if="!i.algorithm.trainable"
                >文档</a-button
              >
              <a-button type="primary" shape="round" @click="calc(i.id)"
                >计算</a-button
              >
            </a-col>
          </a-row>
        </div>

        <!-- instance的详细信息 -->
        <div v-show="i.show" class="instanceDetail">
          <p>
            <b>输入数据：</b> <span>{{ i.inputs }}</span>
          </p>
          <p>
            <b>输出数据：</b><span>{{ i.outputs }}</span>
          </p>
        </div>
      </div>

      <!-- 页码 -->
      <a-pagination
        :current="currentPage"
        :total="totalInstances"
        :defaultPageSize="30"
        v-model="currentPage"
        @change="changePage"
      />
    </div>
  </div>
</template>

<script>
import AlgButton from './algorithmButton'
import util from '../util'
export default {
  components: { AlgButton },
  data() {
    return {
      instances: [],
      instancesInfoShow: [],
      algOperationShow: [],
      toShow: false,
      totalInstances: 0,
      currentPage: 1
    }
  },
  methods: {
    changeShow(idx) {
      this.instances[idx].show = !this.instances[idx].show
      this.$set(this.instances, idx, this.instances[idx])
    },
    changePage() {
      this.getInstance()
      scroll(0, 0)
    },
    async getInstance() {
      const resp = await this.$http.get('instances?page=' + this.currentPage)
      this.instances = resp.data.instances
      if (this.currentPage === 1) {
        this.totalInstances = resp.data.count
      }
      for (const i of this.instances) {
        i.tags = i.tags ? i.tags.split(',') : []
        i.show = false
        i.algShow = false
        i.inputs = ''
        // 输入数据字符串拼接
        for (const field of i.input_field) {
          i.inputs += field.name + '、'
        }
        i.inputs = i.inputs.slice(0, -1)
        // 输出数据字符串拼接
        i.outputs = ''
        for (const field of i.output_field) {
          i.outputs += field.name + '、'
        }
        i.outputs = i.outputs.slice(0, -1)
      }
    },
    calc(iid) {
      this.$router.push('/calc/' + iid)
    },
    toHelpPage(aid) {
      util.toAlgHelp(aid, this.$router)
    }
  },
  created() {
    this.getInstance()
  }
}
</script>

<style scoped>
#rootDiv {
  min-height: 100%;
  width: 100%;
}
.algLink {
  font-weight: bold;
  padding: 0 0 0 0;
}
.instanceDetail {
  margin-top: 1.5rem;
  border-top: 1px solid lightgray;
  padding-top: 1rem;
}
</style>
